import { Theme } from '@mui/material';

export const cardSx = {
  '&.MuiPaper-elevation0': {
    '&.MuiCard-root': {
      borderRadius: 0,
      width: '100%',
      padding: '0px 16px',
      '&:hover': {
        backgroundColor: ({ palette }: Theme) => palette.background.light,
        '& .MuiCardHeader-action': {
          span: {
            display: 'none',
          },
          button: {
            display: 'flex',
          },
        },
      },
    },
    '& .MuiCardHeader-root': {
      display: 'flex',
      padding: 0,
      marginTop: '16px',
      minHeight: '28px',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& .MuiCardHeader-content': {
      display: 'flex',
      flex: 'none',
      alignItems: 'center',
    },
    '& .MuiCardHeader-action': {
      margin: '0px',
      flex: 'none',
      alignSelf: 'auto',
      span: {
        display: 'flex',
      },
      button: {
        display: 'none',
      },
    },
    '& .MuiCardContent-root': {
      padding: '0px 0px 16px 0px',
      borderBottom: `1px solid white`,
      borderBottomColor: 'border.light',
    },
  },
} as const;
